import { ListItemIcon, ListItemText, MenuItem, MenuList } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { featuresConfig } from "config/features";
import { useGoTopDown } from "features/orthoCam/hooks/useGoTopDown";
import { Picker, renderActions, selectPicker } from "features/render";
import { selectEnabledWidgetKeys } from "slices/explorer";

import { ActiveIcon } from "./activeIcon";

export function ClippingMenu({ onSelect }: { onSelect?: () => void }) {
    const activePicker = useAppSelector(selectPicker);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const enabledWidgets = useAppSelector(selectEnabledWidgetKeys);
    const goTopDown = useGoTopDown();

    const togglePicker = (picker: Picker) => {
        dispatch(renderActions.setPicker(picker === activePicker ? Picker.Object : picker));
        onSelect?.();
    };

    return (
        <MenuList>
            {enabledWidgets.has(featuresConfig.clippingPlanes.key) && (
                <MenuItem onClick={() => togglePicker(Picker.ClippingPlane)}>
                    <ListItemIcon>
                        <ActiveIcon
                            Icon={featuresConfig.clippingPlanes.Icon}
                            active={activePicker === Picker.ClippingPlane}
                        />
                    </ListItemIcon>
                    <ListItemText>{t("clippingPlane")}</ListItemText>
                </MenuItem>
            )}
            {enabledWidgets.has(featuresConfig.crossSection.key) && (
                <MenuItem
                    onClick={async () => {
                        togglePicker(Picker.CrossSection);
                        await goTopDown();
                    }}
                >
                    <ListItemIcon>
                        <ActiveIcon
                            Icon={featuresConfig.crossSection.Icon}
                            active={activePicker === Picker.CrossSection}
                        />
                    </ListItemIcon>
                    <ListItemText>{t("crossSection")}</ListItemText>
                </MenuItem>
            )}
        </MenuList>
    );
}
